import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "triangle-down",
  "use": "triangle-down-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 5\" id=\"triangle-down\"><path fill-rule=\"evenodd\" d=\"M0 0l5 5 5-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol